import React from 'react';
import { DefaultSecurityIcon } from './styled-components';
export var DefaultSecurityLogo = function DefaultSecurityLogo(_ref) {
  var text = _ref.text,
      testId = _ref.testId,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(DefaultSecurityIcon, {
    "data-testid": testId,
    className: className
  }, text);
};